import invariant from "tiny-invariant";
export var toSelector = function (rule) { return ".".concat(rule.split(" ").filter(Boolean).join(".")); };
export var toVar = function (varFunction) {
    var matches = varFunction.match(/var\((--[^,)]+)\)/);
    invariant(!!matches, "".concat(varFunction, " wasn't in the expected format"));
    var varString = matches[1];
    invariant(!!varString, "Couldn't extract variable name from ".concat(varFunction));
    return varString;
};
